import {RoleModel} from "../../shared/models/role/role.model";

export const employeeRole: RoleModel = {
  name: 'employee-role',
  nameDutch: 'Werknemer',
  employee: {
        view: false,
        add: false,
        edit: false,
        delete: false,
    },
    customer: {
        view: false,
        add: false,
        edit: false,
        delete: false,
        addUser: false,
        editUser: false,
    },
    project: {
        view: true,
        others: true,
    },
    firePartition: {
        view: true,
    },
    printQr: {
        view: true,
        generate: true,
    }
}
